import { ALERTS_STATE, ALERT_DISPLAY, ALERT_PROCESS, ALERT_REMOVE } from './constants'
import stateBase from './state'

const initialState = stateBase[ALERTS_STATE]

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ALERT_DISPLAY: {
      return [
        {
          ...action.payload,
          severity: action.payload.severity ?? 'error',
          visible: true,
          processed: false,
        },
        // ...state,  // For now we only allow one alert at a time
      ]
    }

    case ALERT_PROCESS: {
      const indexToRemove = action.payload
      return state.map((alert, index) =>
        index === indexToRemove ? { ...alert, processed: true } : alert
      )
    }

    case ALERT_REMOVE: {
      const indexToRemove = action.payload
      return state
        .map((alert, index) => (index === indexToRemove ? { ...alert, visible: false } : alert))
        .filter(alert => alert.visible)
    }

    default:
      return state
  }
}

export default reducer
